import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'
import { IBrand } from '../../shared/interfaces/brand';
import { IBillerBrand } from '../../shared/interfaces/biller-brand';
import { IViewableDocument } from '../../interfaces/viewable-document';
//import { AppConfigService} from '../app-config.service';
import { environment } from '../../../environments/environment';
import { ErrorProcessorService }  from "../../shared/services/error-processor.service";

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  protected baseUrl = environment.apiServer.portalUrl;
  // protected basicAuth = environment.appSetting.portalAuth;
  // protected baseAuth = environment.appSetting.baseAuth;
  protected authServerUrl = environment.apiServer.authServerUrl;

  private brandCodesUrl = this.baseUrl + '/common/brands'; 
  private brandCodeUrl = this.baseUrl + '/common/brands/{brandCode}'; 
  private brandsWithRegionUrl = this.baseUrl + '/common/brands/with-regions'; 
  private brandWithRegionUrl = this.baseUrl + '/common/brands/with-regions/{brandCode}'; 
  private adhocUrl = '/adhoc';
  private authBrandCodesUrl = this.authServerUrl + '/auth/brands/billers';

  private viewableDocumentsUrl = this.baseUrl + '/view-docs/{brandCode}';

  // private headers = new HttpHeaders()
  //   .set('Authorization', this.basicAuth)
  // private baseHeaders = new HttpHeaders()
  //   .set('Authorization', this.baseAuth);

  constructor(
    private http: HttpClient,
    private errorProcessorService: ErrorProcessorService
    ) { }

  // Get all brands
  // getBrands(): Observable<IBrand[]> {
  //    console.log('baseUrl', this.baseUrl);
  //   return this.http.get<IBrand[]>(this.brandCodesUrl, {responseType: 'json'})
  //   .pipe(catchError(this.handleError))
  // }

  // Retrieve all brands
  getBrands(): Observable<IBillerBrand[]> {
    console.log('baseUrl', this.authBrandCodesUrl);
   return this.http.get<IBillerBrand[]>(this.authBrandCodesUrl, {responseType: 'json'})
   .pipe(
    catchError(this.errorProcessorService.handleError)
   )
  }

  // Get all brands
  getBrandsWithRegion(): Observable<IBrand[]> {
    // console.log('baseUrl', this.baseUrl);
    return this.http.get<IBrand[]>(this.brandsWithRegionUrl, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  // Get one given brand 
  getBrandWithRegion(brandCode: string): Observable<IBrand> {
    // console.log('brandService: ', 'inside getBrandWithRegion');
    let url = this.brandWithRegionUrl.replace('{brandCode}', brandCode);
    return this.http.get<IBrand>(url, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  // Get brands for a specific enviromental region
  getEnvBrands(envRegion: string): Observable<IBrand[]> {
    return this.http.get<IBrand[]>(this.brandCodesUrl, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  // Get a list of enrolled accounts for a brand
  getEnrolledAccounts(brandCode: string, recepient: string, baseUrl: string) {
    let request = {
      "adHocReportType": "ENROLLED_ACCOUNTS_LIST",
      "brandCode": brandCode,
      "recepientEmailAddresses": [recepient]
    }
      var url = baseUrl.replace('Walletron','reports') + this.adhocUrl;
      return this.http.post<string>(url, request, {responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
  }

  modifyBrand(brand: IBrand) {
    let url = this.brandCodeUrl.replace('{brandCode}', brand.brandCode);
    return this.http.put(url, brand, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  // Methods related to Viewable Documents

  // List out all viewable documents on S3 bucket for the given brand code
  getViewableDocuments(brandCode: string): Observable<IViewableDocument[]> {
    let url = this.viewableDocumentsUrl.replace('{brandCode}', brandCode);
      return this.http.get<IViewableDocument[]>(url, {responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
  }

  // Upload a viewable document to S3 bucket
  addViewableDocument(brandCode: string, viewableDocumentFile: any): Observable<any>{
    let url = this.viewableDocumentsUrl.replace('{brandCode}', brandCode);
    let formData = new FormData();
    formData.append("viewableDocument", viewableDocumentFile);
    formData.append("fileType", viewableDocumentFile.type);
    // console.log('addViewableDocument - filetype', viewableDocumentFile.type);
    return this.http.post<any>(url, formData, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  // Delete a viewable document from S3 bucket
  deleteViewableDocument(brandCode: string, documentName: string): Observable<any>{
    let url = this.viewableDocumentsUrl.replace('{brandCode}', brandCode);
    // var headers = new HttpHeaders()
    // .set('request-origin', documentName);
    const body = {
      brandCode: '',
      documentName: documentName,
      documentUrl: '',
      lastModifiedDate: ''
    };
    // return this.http.request<any>('DELETE', url, {headers, body})
    return this.http.put<any>(url, body, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }


}
